import {del, post, put} from "../util/http.service";

export const createPortfolioTransaction = transaction => post("/portfolio/transactions", transaction);

export const updatePortfolioTransaction = (id, transaction) => put("/portfolio/transactions/" + id, transaction);

export const deletePortfolioTransaction = id => del("/portfolio/transactions/" + id);
